'use client';
import { useState, useEffect, useCallback } from 'react';
import { usePathMatch } from 'hooks/use-path-match';
import { HOMEPAGE_SEARCH_BAR_BANNER } from '../../../(home)/_constants/constants';
import { MAIN_CAT_HEADER_ID } from '@cat-ecom/pcc-components/src/components/header/constants';

const useSearchBarVisibility = (isSearchBarInHeader) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const isRouterUpdate = usePathMatch();

  //this function handles the visibility of top nav search bar based on scroll
  const handleScroll = useCallback(() => {
    const heroSearchHeight = document
      ?.getElementById(HOMEPAGE_SEARCH_BAR_BANNER)
      ?.getBoundingClientRect()?.bottom;
    const topNavHeader = document
      ?.getElementById(MAIN_CAT_HEADER_ID)
      ?.getBoundingClientRect()?.height;
    const isHeroSearchBarBehindHeader = heroSearchHeight - topNavHeader <= 0;
    setIsSearchVisible(isHeroSearchBarBehindHeader);
  }, []);

  useEffect(() => {
    if (isSearchBarInHeader && isRouterUpdate) {
      //Its happening before you see anything on the screen because react invokes useEffect's very quickly.so required setTimeout
      setTimeout(() => {
        handleScroll();
      }, 200);
      window.addEventListener('scroll', handleScroll);
    } else {
      setIsSearchVisible(true);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isSearchBarInHeader, handleScroll, isRouterUpdate]);

  return { isSearchVisible };
};

export default useSearchBarVisibility;
